
import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { setRedirectToLeads } from '../app-context/leadsSlice';
import { useDispatch } from 'react-redux';
import { OfferProductionModel } from '../models/OfferProductionModel'
type Props = {
    leadId?: string;
    onClick?: Function;
    saveOfferAndShowProduction?: Function;
    lead?: any
    licenseNumber: string;
};
export const SaveOfferButton = (props: Props) => {

    const dispatch = useDispatch();


    const [showModel, setShowModel] = useState<boolean>(false);
    const [showProduction, setShowProduction] = useState<boolean>(false);

    useEffect(() => {
        console.log('showProduction', props.licenseNumber == "", props.licenseNumber)
    }, [])


    const navigate = useNavigate();
    const gotoLeads = () => {
        if (props.lead) {
            const lastFilterStr = localStorage.getItem('lastLeadsFilter');
            let savedFilter: any = {};
            if (lastFilterStr && lastFilterStr !== '{}') {
                console.log('JSON.parse(lastFilterStr)', JSON.parse(lastFilterStr))
                savedFilter = JSON.parse(lastFilterStr);
                // savedFilter.searchText = ownerCustomer.firstName + " " + ownerCustomer.lastName;
                savedFilter.searchText = props.lead.firstName + " " + props.lead.lastName;
                savedFilter.createDateFrom = null;
                savedFilter.SortBy = null;
                console.log('lastLeadsFilter', JSON.stringify(savedFilter))

                localStorage.setItem('lastLeadsFilter', JSON.stringify(savedFilter));
            }
        }

        navigate('/Leads');
    }
    const onClickToSaveAndProduction = (e: any) => {
        console.log('saveOfferBtn clicked');
        if (props.leadId) {
            console.log('saveOfferBtn clicked', props.leadId);
            localStorage.setItem('offeredLeadId', props.leadId);
            // setTimeout(()=>{
            //     // props.openProduction && props.openProduction(e)
            // }, 300)
        }
        if (props.saveOfferAndShowProduction) {
            props.saveOfferAndShowProduction(e)
        }
    }

    const onClickAndGoToLead = (e: any) => {
        console.log('saveOfferBtn clicked');
        if (props.leadId) {
            dispatch(setRedirectToLeads(true));
            console.log('saveOfferBtn clicked', props.leadId);
            localStorage.setItem('offeredLeadId', props.leadId);
            setTimeout(() => {
                setShowModel(false);
                gotoLeads()
            }, 300)
        }
        if (props.onClick) {
            props.onClick(e)
        }
    }

    const onClick = async (e: any) => {

        if (props.leadId) {
            var getIsThereOpenProductionByOffer = await new OfferProductionModel().getIsThereOpenProductionByOffer(props.leadId);
            console.log('getIsThereOpenProductionByOffer', getIsThereOpenProductionByOffer)
            setShowProduction(getIsThereOpenProductionByOffer);
        }
        setShowModel(true);
    }

    const handleOverlayClick = (e: React.MouseEvent<HTMLDivElement>) => {
        if (e.target === e.currentTarget) {
            setShowModel(false);
        }
    };
    return (
        <>
            {/* <button onClick={(e: any) => onClick(e)} className="button white data-card-action" >
                שמור
            </button> */}

            <button onClick={(e: any) => /*onClickAndGoToLead*/onClick(e)} className="button white data-card-action" >
                שמור
            </button>


            {showModel &&
                <div
                    onClick={handleOverlayClick}
                    className='wapper-save-btn'
                >
                    <div
                        onClick={(e) => e.stopPropagation()} // Prevent click events from reaching the overlay
                        className='model-content'
                    >
                        <>
                            <h2> שמירת הצעה </h2>
                            {props.licenseNumber.length > 0 && <>
                                {showProduction ? "" : <button onClick={(e: any) => onClickToSaveAndProduction(e)} className='save-btn-option' disabled={props.licenseNumber == ""}>
                                    שמירה ומעבר להפקה
                                </button>}
                            </>}


                            <button onClick={(e: any) => onClickAndGoToLead(e)} className='save-btn-option'>
                                שמירה ומעבר לליד
                            </button>
                        </>
                    </div>
                </div>
            }
        </>
    )
}